<template>
    <transition name="fade" mode="out-in">
    <div class="modal-backdrop">
        <div class="container">
            <div class="modal">
                <div class="modal-header">
                    <h3>{{modalTitle}}</h3>
                </div>
                <div class="modal-content">
                    <video ref="video" :poster="posterImage" controls autoplay="false" class="fullwidth">
                        <source :src="videoSource" type="video/mp4">
                    </video>
                </div>
                <div class="modal-footer"></div>
            </div>
            <div class="modal-close">
                <div class="button-close" @click="close">Close</div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
export default {
    name: 'VideoModal',
    props: ['videoSource','modalTitle','posterImage'],
    methods: {
        close() {
            this.$refs.video.pause(); //Stop video playing when the modal closes
            this.$emit('close'); //Sends event "close" back to parent component
        }
    },
    mounted() {
        this.$refs.video.pause(); //Pauses video on app mount
    }
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(9, 15, 32, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
}

.container {
    max-width: 800px;
    display: flex;
    flex-direction: column;
}

.modal {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.modal-header {
    display: flex;
    justify-content: center;
}

.modal-close {
    flex: 1 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 64px;
}

.button-close {
    display: flex;
    white-space: nowrap;
    border: 1px solid transparent;
    font-size: 20.25px;
    line-height: 1.7;
    border-radius: 2rem;
    font-weight: bold;
    color: white;
    text-decoration: none;
    background-color: #4979FF;
    padding: .75rem 2.5rem;
    text-transform: uppercase;
    &:focus,:active {
        border: none;
        outline: none;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .35s;
}

.fade-enter {
    opacity: 0;
}

.fade-enter-to {
    opacity: 1;
}

.fade-leave {
    opacity: 1;
}

.fade-leave-to {
    opacity: 0;
}
</style>